module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABAElEQVQ4ja2UsUpDMRiFv1taC8WxncQXsJODuwgFK/99Eh/Czd1RcCt9ghyqm1PnDkVaujgIIk4FXTUdegelub0pzYFAyDn/l/yBJCMg7z2SukAHuAHOC2sIPAAfZjbPsmyjdnMFcM7dA8fAJ3AKNArrC5gBR8Aiz/PrUH0IOPXes20456ah2loJ8ydi32CmDPhPkpoxuWgg0EsNvEwGlFRLCgTOgHZKYB84lPQiaZACeAGMgRPguSpcjwBesW75FXiqClee0My+i+nEzN73Bv7RKCa0C/AxJhRzhwBL4C0Z0MyWkRvv1PJewINtP4ykFhD0y1q+A2bFOw7pF7gNGSuH9FQVAdqetwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/smallIcon/second_icon_battery.png
// module id = EuK7
// module chunks = 1